import axios from 'axios';
import { loader } from './../../layout/loader';

import {
CREATE_NEW_DRAFT_CATEGORY,
EDIT_DRAFT_CATEGORY,
SET_TRANSLATIONS,
SET_CATEGORIES,
DELETE_CATEGORY,
DELETE_CATEGORY_WITH_DRAFTS
} from '../constants/drafts-constants'

import {closePopup} from '../actions/popup_actions';

import { initSettings, startAjax, endAjax } from '../actions/settings_actions';

/**
 * Create new Draft Category
 * @param title
 * @param description
 * @returns {{type, title: *, description: *}}
 */
export function createNew(title, description) {
    return {
        type: CREATE_NEW_DRAFT_CATEGORY,
        title,
        description,
    }
}

/**
 * / Edit Draft Category
 * @param title
 * @param description
 * @param id
 * @returns {{type, id: *, title: *, description: *}}
 */
export function editDraftCategory(title, description, id) {
    return {
        type: EDIT_DRAFT_CATEGORY,
        id,
        title,
        description
    }
}

export function deleteCategory(id) {
    return {
        type: DELETE_CATEGORY,
        id
    }
}

export function deleteCategoryAndDrafts(id, count) {
    return {
        type: DELETE_CATEGORY_WITH_DRAFTS,
        id,
        count
    }
}

/**
 * Add All Categories from server to reducer
 * @param categories
 * @returns {{type, categories: *}}
 */
export function setCategories(categories) {
    return {
        type: SET_CATEGORIES,
        categories
    }
}

/**
 * Set translations from server to reducer
 * @param translations
 * @returns {{type, translations: *}}
 */
export function setTranslations(translations) {
    return {
        type: SET_TRANSLATIONS,
        translations
    }
}

/**
 * Get init data from server
 * @returns {Function}
 */
export function initCategories() {
    return function (dispatch) {
        loader.show();
        let path, routingPath, n, result;
        if (window.fos == undefined) {
            path = "http://localhost:3005/drafts"
        } else {
            routingPath = Routing.generate('app_estimation_draft_category.get_all');
            path = routingPath;
        }
        axios.get(path, {
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(function (response) {
            loader.hide();
            dispatch(setTranslations(response.data.trans));
            dispatch(setCategories(response.data.categories));
            dispatch(initSettings(response.data.all));
        })
        .catch(function (response) {
            console.log(response)
        })
    }
}

/**
 * Save category changes ( title, desc )
 * @param title
 * @param desc
 * @param id
 * @returns {Function}
 */
export function saveChanges(title, desc, id) {
    let data = {
        title,
        desc
    };
    return function (dispatch) {
        loader.show();
        let path, routingPath, n, result;
        if (window.fos == undefined) {
            path = `http://localhost:3005/drafts/${id}`
        } else {
            routingPath = Routing.generate('app_estimation_draft_category.put', { "id": id });
            path = routingPath;
        }
        axios.patch(path, data, {headers : {'Accept': 'application/json'}})
        .then(function (response) {
            loader.hide(response);
            dispatch(editDraftCategory(title, desc, id));
            dispatch(closePopup());
        })
        .catch(function (response) {
            console.log(response);
        })
    }
}

/**
 * Save new category to server. Add category to reducer as callback
 * @param title
 * @param desc
 * @param id
 * @returns {Function}
 */
export function saveNewCategory(title, desc) {
    let data = {
        title,
        desc
    };
    return function (dispatch) {
        loader.show();
        let path, routingPath, n, result;
        if (window.fos == undefined) {
            path = "http://localhost:3005/drafts"
        } else {
            routingPath = Routing.generate('app_estimation_draft_category.post');
            path = routingPath;
        }
        axios.post(path, data, {headers : {'Accept': 'application/json'}})
        .then(function (response) {
            loader.hide(response);
            dispatch(createNew(title, desc));
            dispatch(closePopup());
        })
        .catch(function (response) {
            console.log(response);
        })
    }
}

/**
 * Delete category with drafts(serverside)
 * @param id
 * @returns {Function}
 */
export function deleteCategoryWithDrafts(id, count) {
    return function (dispatch) {
        loader.show();
        let path, routingPath, n, result;
        if (window.fos == undefined) {
            path = `http://localhost:3005/drafts/${id}/all`
        } else {
            routingPath = Routing.generate('app_estimation_draft_category.delete_all', { "id": id });
            path = routingPath;
        }
        axios.delete(path)
        .then(function (response) {
            loader.hide(response);
            dispatch(deleteCategoryAndDrafts(id, count));
            dispatch(setInactiveDelete());
        })
        .catch(function (response) {
            console.log(response);
        })
    }
}

/**
 * Delete category without deleting categories(serverside)
 * @param id
 * @returns {Function}
 */
export function deleteSingleCategory(id) {

    return function (dispatch) {
        loader.show();
        let path, routingPath, n, result;
        if (window.fos == undefined) {
            path = `http://localhost:3005/drafts/${id}`
        } else {
            routingPath = Routing.generate('app_estimation_draft_category.delete', { "id": id });
            path = routingPath;
        }
        axios.delete(path)
        .then(function (response) {
            loader.hide(response);
            dispatch(deleteCategory(id));
            // dispatch(setInactiveDelete());
        })
        .catch(function (response) {
            console.log(response);
        })
    }
}



// WEBPACK FOOTER //
// ./src/_app/drafts/actions/drafts_actions.js